<template>
    <div class="opui-form-group">
        <label>{{ $e('Webhook URL') }}</label>
        <div class="opui-form-slug-wrapper">
            <input type="text"
                   class="opui-form-control opui-pl-3"
                   v-model="webhookUrl"
                   readonly
                   disabled
            />
            <i v-if="isClipboardApiAvailable" class="opui-fa opui-fa-copy" @click="copyUrl"></i>
        </div>
    </div>

    <!-- <div class="opui-form-group">
        <div class="request-log" v-if="isListening" style="border: 1px solid #ddd; background: #eee; border-radius: 4px; padding: 16px; margin: 16px 0 0 0;">
            {{ listenData ? listenData : '...' }}
        </div>
    </div> -->

    <hr class="opui-mt-4">
<!--    <p><small>Workflow: {{ workflow.uid }}</small></p>-->
<!--    <p><small>Trigger: {{ trigger.uid }}</small></p>-->

    <div class="opui-form-group" v-if="trigger.settings && trigger.settings.fields">
        <label>
            <a href="#" @click.prevent="toggleFields">
                {{ $e('Incoming data') }}
                <small>({{ trigger.settings.fields.length ? trigger.settings.fields.length : 0 }} fields)</small>
            </a>
        </label>

        <div class="opui-row" v-if="showFields">
            <div class="opui-col">
                <div class="opfl-field-map-item opui-row" v-for="(mapItem, index) in this.trigger.settings.fields">
                    <div class="opui-col">
                        <input type="text" v-model="mapItem.id" class="opui-form-control" required />
                    </div>

                    <div class="opui-col">
                        <select v-model="mapItem.type" class="opui-form-control">
                            <optgroup label="Generic">
                                <option value="number">{{ $e('Number') }}</option>
                                <option value="text">{{ $e('Text') }}</option>
                                <option value="text">{{ $e('Boolean') }}</option>
                            </optgroup>
                            <optgroup label="Dynamic">
                                <option value="dynamic/email">{{ $e('Email') }}</option>
                                <option value="dynamic/post">{{ $e('WordPress Post') }}</option>
                                <option value="dynamic/user">{{ $e('Registered User') }}</option>
                            </optgroup>
                        </select>
                    </div>

                    <div class="opui-col-1">
                        <a href="#" @click.prevent="removeField(index)" class="opui-btn opui-btn-link"><i class="opui-fa opui-fa-trash opui-text-gray-400"></i></a>
                    </div>
                </div>

                <div class="opui-row">
                    <div class="opui-col">
                        <a href="#" @click.prevent="addField" class="opui-btn opui-btn-success opui-btn-xs">+ {{ $e('Add new') }}</a>
                        <span class="opui-mx-2">&mdash;</span>
                        <a href="#" @click.prevent="startListen" class="opui-btn opui-btn-secondary opui-btn-xs" v-if="! isListening">Listen</a>
                        <a href="#" @click.prevent="stopListening" class="opui-btn opui-btn-warning opui-btn-xs " v-else>Stop listening</a>
                        <!-- <p v-if="! this.workflow.active"><hr class="opui-mt-3"><small><em>For the listening to work, for now the workflow needs to be turned on (later this won't be necessary)</em></small></p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        workflow:  { type: Object, required: true },
        trigger:   { type: Object, required: true },
    },
    data() {
        return {
            isListening:        false,
            listenIntervalTime: 1500,
            listenAttempts:     0,
            maxListenAttempts:  30,
            listenData:         {},
            showFields:         false,
            isClipboardApiAvailable: navigator.clipboard ? true : false,
        }
    },
    computed: {
        webhookUrl() {
            return this.workflow.url
        },
    },
    mounted() {
        if (! this.trigger.settings)        this.trigger.settings        = {}
        if (! this.trigger.settings.fields) this.trigger.settings.fields = []

        this.$events.on('triggerModalClosed', () => {
            this.stopListening()
        });
    },
    methods: {
        startListen() {
            // Check if already running listener
            if (this.isListening) {
                this.stopListening()
            }

            this.listenAttempts = 0
            this.listen()
            this.isListening = true
        },

        async listen() {
            if (this.listenAttempts < this.maxListenAttempts) {
                // On the first attempt we need to pass a flag
                let init        = this.listenAttempts === 0;
                let status      = null
                let response    = null
                let workflowUid = this.workflow.uid ? this.workflow.uid : '__new__'

                try {
                    response = await this.$http.post('workflows/webhook/listen/' + workflowUid, {
                        init: init,
                    })
                    status = await response.status
                } catch (e) {
                    console.error(e);
                }

                this.listenAttempts++
                if (status && response && status === 200) {
                    this.listenData = response.data.data

                    // Check if got a log row and fields, and stop listening
                    if (this.listenData.fields && this.listenData.fields.length) {
                        this.stopListening()

                        // Add fields from log to data field map
                        this.trigger.settings.fields = this.listenData.fields

                        this.$toast.success('Done listening.')
                    }

                } else {
                    this.$toast.error('Error on listen.')
                    this.stopListening()
                }

                // Check if reached max attempts
                if (this.listenAttempts >= this.maxListenAttempts) {
                    this.stopListening()
                } else {
                    setTimeout(() => { this.listen() }, this.listenIntervalTime)
                }
            }
        },

        /**
         * Stop listening for incoming requests
         */
        stopListening() {
            this.isListening    = false
            this.listenAttempts = this.maxListenAttempts + 1
        },

        /**
         * Add new field to the field map
         */
        addField() {
            this.trigger.settings.fields.push({
                id: '',
                label: '',
                type: 'text',
                value: '',
            })
        },

        /**
         * Remove a field from the list
         * @param index
         */
        removeField(index) {
            this.trigger.settings.fields.splice(index, 1)
        },

        toggleFields() {
            this.showFields = ! this.showFields
        },

        /**
         * Copy URL using Clipboard API
         */
        copyUrl() {
            navigator.clipboard
                .writeText(this.webhookUrl)
                .then(() => {
                    this.$toast.success(this.$e('URL copied'))
                })
                .catch(() => {
                    this.$toast.error(this.$e('Error while copying URL'))
                })
        },
    }
}
</script>
